import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import parallaxStyle from "assets/jss/material-kit-react/components/parallaxStyle.jsx"

import joinTheMovementCta from "data/join-the-movement-cta-hero.json"

// Sections for this page
import CTASection from "components/CTASection/CTASection.jsx";

import Organize from "components/Background/Organize.jsx";

const joinTheMovementStyle = {

};

class JoinTheMovementCTA extends React.Component {
  render() {
    const { classes, listIds, ...rest } = this.props;
    return (
      <Organize>
      <CTASection cta={joinTheMovementCta} listIds={[25].concat(listIds)} filterOpacity="0.4"/>
      </Organize>
    );
  }
}

export default withStyles(joinTheMovementStyle)(JoinTheMovementCTA);
